import React from "react";
import IconButton from "@material-ui/core/IconButton";
import InvertColorsIcon from "@material-ui/icons/InvertColors";
import { useTheme } from "@material-ui/core/styles";
import { useThemeMode } from "../../context/ThemeModeContext";

const ThemeToggleIcon = () => {
  const { toggleTheme } = useThemeMode();
  const theme = useTheme();

  return (
    <IconButton
      onClick={toggleTheme}
      aria-label="Toggle Theme"
      style={{
        color: theme.palette.text.primary,
        backgroundColor: "transparent",
        border: `1px solid ${theme.palette.text.border}`,
        borderRadius: 8, 
        width: 40,
        height: 30,
        padding: 0,
        marginLeft: 10,
        transition: "background-color 0.3s, transform 0.2s",
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.backgroundColor = theme.palette.action.hover;
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.backgroundColor = "transparent";
      }}
    >
      <InvertColorsIcon />
    </IconButton>
  );
};

export default ThemeToggleIcon;
